//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Inventory from'./components/inventory.vue'
import Preorder from'./components/preorder.vue'
import Beput from'./components/beput.vue'
import Lack from'./components/lack.vue'
import ElseGoods from'./components/elseGoods.vue'
export default {
  // props: [],
  data: function () {
    return {
      index:"0",
      rules: {},
      form: {
        day: undefined
      },
    }
  },
  components: {
    Inventory,Preorder,Beput,Lack,ElseGoods
  },
  created(){
    this.componentId = Inventory
    if(window.sessionStorage.getItem('tab')){
      this.index = window.sessionStorage.getItem('tab')
      window.sessionStorage.removeItem('tab')
    }
  },
  methods: {
    // handleFormSubmit () {
    //   console.log('form', JSON.stringify(this.form))
    // },
    tabClick(tab){
      // console.log(tab)
      this.index = tab.index
    }
  }
}
